import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { AuthBackgroundVideo } from './auth-background-video.atom'
import { AuthBrandPanel } from './auth-brand-panel.molecule'
import { AuthFooterLinks } from './auth-footer-links.atom'
import { AuthFormPanel } from './auth-form-panel.atom'
import type { AuthLayoutProps } from './auth-layout.interface'
import { AuthMobileLogoBar } from './auth-mobile-logo-bar.atom'

const AUTH_VIDEO_SRC = '/assets/bg/blurred_demo.mp4'

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  heading,
  children,
  headerSlot,
  className,
}): ReactNode => (
  <div className={cn('auth-layout flex min-h-screen flex-col-reverse lg:flex-row', className)}>
    <AuthBrandPanel heading={heading} className="min-h-[200px] lg:min-h-0 lg:w-[45%]" />
    <div className="relative flex flex-1 flex-col overflow-hidden lg:max-h-screen">
      <AuthBackgroundVideo src={AUTH_VIDEO_SRC} />
      <div className="relative z-10 flex flex-1 flex-col lg:max-h-screen lg:overflow-y-auto">
        <AuthMobileLogoBar />
        <AuthFormPanel className="flex-1" headerSlot={headerSlot}>
          {children}
        </AuthFormPanel>
        <AuthFooterLinks />
      </div>
    </div>
  </div>
)
